import '@fontsource-variable/dm-sans'
import 'mapbox-gl/dist/mapbox-gl.css'
import './styles/app.css'
import state, {readStore, writeStore} from './lib/state.js'
import './lib/theme.js'
import './lib/install.js' // early, to catch the browser's install prompt
import './lib/router.js'
import {api, loadFeatures} from './lib/api.js'
import {loadAccount, signInResult} from './lib/account.js'
import {loadStrava, stravaResult} from './lib/strava.js'
import {loadTracks} from './lib/tracks.js'
import {toast} from './views/header.js'

async function boot(){
	// start from the last config we saw (no network wait), refreshing it in the background
	const fetchConfig = api('/config').then(config=>{ writeStore('config', config); return config })
	state.config = readStore('config', null) || await fetchConfig
	fetchConfig.then(config=>state.config = config).catch(()=>{})
	await import('./mr-app.js')
	document.body.appendChild(document.createElement('mr-app'))

	const result = signInResult()
	if( result ) toast(result == 'cancelled' ? 'Sign in cancelled' : 'Couldn’t sign in')

	const strava = stravaResult()
	if( strava ) toast({connected: 'Strava connected', cancelled: 'Strava not connected', noaccess: 'Strava needs access to your activities to show them', failed: 'Couldn’t connect Strava'}[strava] || 'Couldn’t connect Strava')

	await Promise.all([loadFeatures(), loadAccount()])
	loadStrava()
	loadTracks()

	// air quality and snow depths refresh on the server; pick them up when coming back to the app
	let last = Date.now()
	document.addEventListener('visibilitychange', ()=>{
		if( document.visibilityState == 'visible' && Date.now() - last > 10*60*1000 ){
			last = Date.now()
			loadFeatures().catch(()=>{})
			loadAccount()
			loadStrava({force: true})
			loadTracks({force: true})
		}
	})
}

boot().catch(err=>{
	console.error(err)
	document.body.innerHTML = `<p style="font:16px system-ui;padding:40px;text-align:center">MountainReport couldn't start.<br><small>${err.message}</small></p>`
})

// the app shell works offline (only on https or localhost)
if( 'serviceWorker' in navigator && (location.protocol == 'https:' || location.hostname == 'localhost') )
	watchForUpdates()

// A new version installs in the background and waits; offer it with a toast. Checked at launch and
// whenever the app comes back to the foreground.
async function watchForUpdates(){
	let reg
	try{
		reg = await navigator.serviceWorker.register('/sw.js')
	}catch(err){
		return console.warn('service worker:', err.message)
	}

	let offered = false
	const offer = ()=>{
		if( offered || !reg.waiting || !navigator.serviceWorker.controller ) return
		offered = true
		// the app may still be starting
		const show = ()=>document.querySelector('mr-toast') ? toast(update) : setTimeout(show, 500)
		show()
	}
	const update = {
		msg: 'New version ready',
		action: 'Update',
		sticky: true,
		onAction: ()=>{
			updating = true
			reg.waiting?.postMessage('skip-waiting')
		},
	}

	let updating = false
	navigator.serviceWorker.addEventListener('controllerchange', ()=>{ if( updating ) location.reload() })

	reg.addEventListener('updatefound', ()=>{
		const worker = reg.installing
		worker?.addEventListener('statechange', ()=>{ if( worker.state == 'installed' ) offer() })
	})
	offer() // one already waiting from last time

	let lastCheck = Date.now()
	document.addEventListener('visibilitychange', ()=>{
		if( document.visibilityState != 'visible' || Date.now() - lastCheck < 30000 ) return
		lastCheck = Date.now()
		reg.update().then(offer).catch(()=>{})
	})
}
